/* eslint-disable max-len */
import { Logger } from '@deqo/foundation';
import { EventRouter } from '@deqo/podopolis';
import { BoardLiteData, UserLiteData, WorkspaceFolderLiteData, WorkspaceLiteData } from '../api/ApiTypes';
import { AccountLiteData } from '../api/endpoints/me';
import { SettingPatchData } from '../api/endpoints/settings';

const logger = Logger.get('app.events');

export interface AppEventStreams {
    'ready': unknown;
    'push': [string, any];
    'account:patch': { account: Partial<AccountLiteData> };
    'account:setRole': { userId: string, roleName: string };
    'account:userJoin': { user: UserLiteData };
    'account:userLeave': { userId: string };
    'board:create': { board: BoardLiteData };
    'board:delete': { boardId: string };
    'board:move': { boardId: string, workspaceId: string, folderId?: string };
    'board:patch': { board: Partial<BoardLiteData> };
    'board:thumb': { boardId: string };
    'folder:create': { folder: WorkspaceFolderLiteData };
    'folder:delete': { folderId: string };
    'folder:patch': { folder: Partial<WorkspaceFolderLiteData> };
    'settings:patch': SettingPatchData;
    'tasks:changed': { workspaceId: string };
    'template:thumb': { templateId: string };
    'workspace:create': { workspace: WorkspaceLiteData };
    'workspace:patch': { workspace: Partial<Omit<WorkspaceLiteData, 'folders'>> };
    'workspace:delete': { workspaceId: string };
    'workspace:members:add': { workspace: WorkspaceLiteData, user: UserLiteData }; // Once nav has its own scope drop workspace to ref
    'workspace:members:remove': { workspaceId: string, userId: string };
    'user:patch': { userId: string };
    'user:notification': { userId: string };
}

export class AppEvents extends EventRouter<AppEventStreams> {

    public push<K extends keyof AppEventStreams>(type: K, data: AppEventStreams[K]): void {
        logger.log('Event (push):', type, '->', data);
        super.emit(type, data);
        super.emit('push', [type, data]);
    }

    public recv<K extends keyof AppEventStreams>(type: K, data: AppEventStreams[K]): void {
        logger.log('Event (recv):', type, '->', data);
        super.emit(type, data);
    }
}


